import profileSurvey from 'src/modules/profileSurvey/reducer';

const modalsReducers = {
  profileSurvey,
};

export default modalsReducers;
